import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router';
import { useAuth } from '../hooks';
import { routes } from '../routing';
import { useBusinessSetup } from '@/contexts/business-setup-context';

export const NoAuthLayout: React.FC = () => {
  const { isAuthenticated } = useAuth();
  const { hasSetupAccount } = useBusinessSetup();
  const location = useLocation();

  const isAccountSetupRoute = location.pathname === routes.accountSetup;

  if (!isAuthenticated && isAccountSetupRoute) {
    return <Navigate to={routes.login} replace />;
  }

  if (isAuthenticated && hasSetupAccount) {
    return <Navigate to={routes.dashboard} replace />;
  }

  if (isAuthenticated && hasSetupAccount === false && !isAccountSetupRoute) {
    return <Navigate to={routes.accountSetup} replace />;
  }

  return <Outlet />;
};
